import { TitularTooltip } from '@campfire/titular-tooltip';
import { ListItem, Box, Typography, Chip } from '@material-ui/core';
import { Explore, Warning } from '@material-ui/icons';
import React from 'react';
import { useQueryParams, StringParam, NumberParam } from 'use-query-params';
import { DateInfoCard } from '../../../../common/cards/date-info-card/DateInfoCard';
import { QueryParams, RosterStatus, RosterListItem } from '../main-section/roster/roster-types';
import { getDisplayTimeSchedule } from '../../../../common/functions/activity-display-helpers';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { useSharedSessionResults } from '../main-section/roster/RosterHeader';
import { useSharedPromptState } from '../main-section/roster/roster-table/RosterTableSharedState';

interface Props {
  roster: RosterListItem;
  rosterStatus: RosterStatus;
  loading?: boolean;
}

export const RosterItem = (props: Props) => {
  const { theme } = useCampfireTheme();
  const { roster, rosterStatus } = props;

  const [query, setQuery] = useQueryParams({
    activityDate: StringParam,
    activityId: StringParam,
    programId: StringParam,
    activityType: StringParam,
    volunteersNeeded: NumberParam,
    startTime: StringParam,
    endTime: StringParam,
    startDate: StringParam,
    endDate: StringParam,
    ot: StringParam,
  });

  const tooltipStatus = {
    published: 'Roster is published',
    draft: 'Draft exists',
    cancelled: 'Cancelled',
    neutral: 'Roster is not published',
    completed: 'Roster is completed',
    'not-published': 'Roster is completed but not published',
    'report-not-started': 'No reports available',
    'report-missing': 'Some reports are missing',
    'pending-approval': 'Roster pending approval',
  };

  const isSelected = (queryParams: QueryParams) =>
    queryParams.activityId === roster.activityId && queryParams.activityDate === roster.activityDate;

  const { resetPages } = useSharedSessionResults();
  const { setHidePromptForDate } = useSharedPromptState();

  return (
    <TitularTooltip title={tooltipStatus[rosterStatus]} placement={'left'}>
      <ListItem
        onClick={() => {
          setHidePromptForDate(false);
          setQuery({ activityId: roster.activityId, activityDate: roster.activityDate });
          resetPages();
        }}
        style={{
          cursor: 'pointer',
          paddingLeft: '0',
          paddingRight: '0',
        }}
      >
        <DateInfoCard
          date={roster.activityDate}
          color={theme.color.rosters.status[rosterStatus]}
          selected={isSelected(query)}
          size='s'
        >
          <Box display='flex' alignItems='center' justifyContent='space-between' alignSelf='stretch'>
            <Box display={'flex'} flexDirection={'column'} width={roster.volsNeeded < 0 ? '95%' : '100%'}>
              {rosterStatus === 'pending-approval' && (
                <Chip
                  icon={<Warning style={{ fontSize: '12px', color: '#FFC107' }} />}
                  label='Approval Required'
                  size='small'
                  style={{
                    backgroundColor: theme.color.grey.neutralBrand100,
                    color: theme.color.grey.neutral400,
                    fontSize: '9px',
                    height: '18px',
                    marginBottom: '4px',
                    alignSelf: 'flex-start',
                    padding: '0 4px',
                  }}
                />
              )}
              <Typography
                noWrap
                style={{
                  color: theme.color.grey.neutral400,
                  fontSize: '20px',
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                }}
              >
                {roster.activityName}
              </Typography>
              <Typography variant={'caption'} style={{ color: theme.color.grey.neutral200, paddingTop: '6px' }}>
                {`${getDisplayTimeSchedule(roster.startTime, roster.endTime)}`}
              </Typography>
              <Box display='flex' alignItems='center' pt={1}>
                <Explore style={{ color: theme.color.grey.neutral200, fontSize: 14, marginRight: '6px' }} />
                <Typography variant={'caption'} style={{ color: theme.color.grey.neutral200, marginTop: '1px' }}>
                  {roster.programName}
                </Typography>
              </Box>
            </Box>
          </Box>
        </DateInfoCard>
      </ListItem>
    </TitularTooltip>
  );
};
